export const MENU_ITEM_CLASS = 'ui-menu-item'
